<template>
  <div style="width: 100%;overflow: auto">
    <v-item-group
      v-model="template"
      class="d-flex mt-2"
    >
      <v-item
        v-slot="{ active, toggle }"
        value="abriron8"
        class="me-3"
        style="max-width: 50px"
      >
        <v-img
          src="/img/printTemplate/abrironPrint8.png"
          height="50"
          width="50"
          class="text-right pa-2"
          style="border-radius: 10px;"
          :style="{'border' : (active ? '3px solid rgb(0 99 255)' : '0.5px solid #c2c2c2')}"
          @click="toggle"
        />
      </v-item>
      <v-item
        v-slot="{ active, toggle }"
        value="abriron6"
        class="me-3"
        style="max-width: 50px"
      >
        <v-img
          src="/img/printTemplate/abrironPrint6.png"
          height="50"
          width="50"
          class="text-right pa-2"
          style="border-radius: 10px;"
          :style="{'border' : (active ? '3px solid rgb(0 99 255)' : '0.5px solid #c2c2c2')}"
          @click="toggle"
        />
      </v-item>
      <v-item
        v-slot="{ active, toggle }"
        value="abriron5"
        class="me-3"
        style="max-width: 50px"
      >
        <v-img
          src="/img/printTemplate/abrironPrint5.png"
          height="50"
          width="50"
          class="text-right pa-2"
          style="border-radius: 10px;"
          :style="{'border' : (active ? '3px solid rgb(0 99 255)' : '0.5px solid #c2c2c2')}"
          @click="toggle"
        />
      </v-item>
      <v-item
        v-slot="{ active, toggle }"
        value="abriron1"
        class="me-3"
        style="max-width: 50px"
      >
        <v-img
          src="/img/printTemplate/abrironPrint1.png"
          height="50"
          width="50"
          class="text-right pa-2"
          style="border-radius: 10px;"
          :style="{'border' : (active ? '3px solid rgb(0 99 255)' : '0.5px solid #c2c2c2')}"
          @click="toggle"
        />
      </v-item>
      <v-item
        v-slot="{ active, toggle }"
        value="abriron2"
        class="me-3"
        style="max-width: 50px"
      >
        <v-img
          src="/img/printTemplate/abrironPrint2.png"
          height="50"
          width="50"
          class="text-right pa-2"
          style="border-radius: 10px;"
          :style="{'border' : (active ? '3px solid rgb(0 99 255)' : '0.5px solid #c2c2c2')}"
          @click="toggle"
        />
      </v-item>
      <v-item
        v-slot="{ active, toggle }"
        value="abriron3"
        class="me-3"
        style="max-width: 50px"
      >
        <v-img
          src="/img/printTemplate/abrironPrint3.png"
          height="50"
          width="50"
          class="text-right pa-2"
          style="border-radius: 10px;"
          :style="{'border' : (active ? '3px solid rgb(0 99 255)' : '0.5px solid #c2c2c2')}"
          @click="toggle"
        />
      </v-item>
      <v-item
        v-slot="{ active, toggle }"
        value="abriron4"
        class="me-3"
        style="max-width: 50px"
      >
        <v-img
          src="/img/printTemplate/abrironPrint4.png"
          height="50"
          width="50"
          class="text-right pa-2"
          style="border-radius: 10px;"
          :style="{'border' : (active ? '3px solid rgb(0 99 255)' : '0.5px solid #c2c2c2')}"
          @click="toggle"
        />
      </v-item>
    </v-item-group>
  </div>
</template>

<script>
  export default {
    name: 'PrintTemplateSelector',
    components: {
    },
    data: () => ({
      template: null,
    }),
    watch: {
      template (val) {
        this.$emit('input', val)
        if (val) {
          localStorage.setItem('invoicePrintTemplate', val)
        } else {
          localStorage.removeItem('invoicePrintTemplate')
        }
      },
    },
    activated () {
    },
    beforeMount () {
      var template = localStorage.getItem('invoicePrintTemplate')
      if (template !== undefined) {
        this.template = template
      }
    },
    mounted () {
    },
    methods: {
    },
  }
</script>

<style scoped>

</style>
